import React from "react";
import { format } from "date-fns";

export interface TimeViewProps {
    value: Date;
}

const TimeView:React.FC<TimeViewProps> = ({ value }) => (<span>{format(value, 'HH:mm')}</span>)

export default TimeView;